import { render, staticRenderFns } from "./newIndexPage.vue?vue&type=template&id=65dbed06&"
import script from "./newIndexPage.vue?vue&type=script&lang=js&"
export * from "./newIndexPage.vue?vue&type=script&lang=js&"
import style0 from "./newIndexPage.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports